import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { DEFAULT_CONTENT } from "@/data/content";

const ContentContext = createContext({ content: DEFAULT_CONTENT, loading: true });
export const useContent = () => useContext(ContentContext);

// Merge stored content over defaults at the top-level key granularity.
function merge(stored) {
  const out = { ...DEFAULT_CONTENT };
  if (stored && typeof stored === "object") {
    for (const key of Object.keys(DEFAULT_CONTENT)) {
      const v = stored[key];
      if (Array.isArray(v) && v.length) out[key] = v;
      else if (v && !Array.isArray(v) && typeof v === "object") out[key] = { ...DEFAULT_CONTENT[key], ...v };
    }
  }
  return out;
}

export function ContentProvider({ children }) {
  const [content, setContent] = useState(DEFAULT_CONTENT);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    api
      .get("/content")
      .then((res) => {
        if (active) setContent(merge(res.data));
      })
      .catch(() => {})
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, []);

  return <ContentContext.Provider value={{ content, loading }}>{children}</ContentContext.Provider>;
}
